<header>
    Enlazando: {{materiasString}}
</header>
<mat-dialog-content>
    <form [formGroup]="classroomSelectForm">
        <mat-form-field>
            <mat-label>Clases de Classroom disponibles</mat-label>
            <mat-select formControlName="classroomSelect">
                <mat-option *ngFor="let class of classrooms" [value]="class.id">
                    {{class.name + (class.section ?'(' + class.section + ')' : '')}}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="classroomSelectForm.get('classroomSelect').invalid && classroomSelectForm.get('classroomSelect').touched">
                Este campo es requerido.
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancelar</button>
    <button mat-button (click)="submit()">Enlazar</button>
</mat-dialog-actions>
